__turbopack_context__.v({
  "carousel-mobile-full-bleed-grid": "reviews-container-module-scss-module__X_BwRq__carousel-mobile-full-bleed-grid",
  "carousel-tablet-full-bleed-single-item-grid": "reviews-container-module-scss-module__X_BwRq__carousel-tablet-full-bleed-single-item-grid",
  "no-reviews-placeholder": "reviews-container-module-scss-module__X_BwRq__no-reviews-placeholder",
});
